// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5519c172","703":"d01abad6","787":"110eb84e"}[chunkId] + ".chunk.js";
};